import React, { Component } from 'react';
import PT from 'prop-types';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';
import { map, includes, filter, split, find } from 'lodash';
import { getObjectPropertyValue } from './util';

const ConditionalWrapper = ({ condition, wrapper, children }) => 
  condition ? wrapper(children) : children;

export class ReactFormFieldTags extends Component {
    constructor(props) {
        super(props);
        this.handleChecked = this.handleChecked.bind(this);
        this.handleTextInputChange = this.handleTextInputChange.bind(this);
    }

    handleChecked(e) {
        let tagsArray = [];
        if (this.props.value !== "")
            tagsArray = split(this.props.value, ',');

        if (e.target.checked)
            tagsArray.push(e.target.name);
        else
            tagsArray = filter(tagsArray, tag => tag !== e.target.name);
        
        let stringValues = tagsArray.join(',');
        if (!e.target.checked) {
            const subField = find(this.props.possibleValues, ["value", e.target.name]).subField;
            if (subField !== undefined) {
                this.props.onFieldOrSubFieldChange(
                     stringValues, 
                    {
                        name: subField,
                        value: ""
                    }
                );
            }
            else this.props.onChange(stringValues);
        }
        else this.props.onChange(stringValues);
    }

    handleTextInputChange(subFieldName, newVal) {
        if (this.props.onSubFieldChange)
            this.props.onSubFieldChange(subFieldName, newVal);
    }

    render() {
        let hasMoreThanThreeValues = this.props.possibleValues.length > 2;
        const CheckboxView = this.props.viewProvider.getCheckboxView();
        const CheckboxWithTextInputView = this.props.viewProvider.getCheckboxWithTextInputView();
        const checkboxes = map(this.props.possibleValues, (item, i) => {
            const label = getObjectPropertyValue(item, 'label', this.props.lang);
            let viewToDisplay;

            if (item.subField !== undefined) {
                const subField = find(this.props.subFields, ["name", item.subField]);
                viewToDisplay = <CheckboxWithTextInputView
                    key={i}
                    name={item.value}
                    value={includes(this.props.value, item.value)}
                    onChange={this.handleChecked} 
                    isRequired={this.props.isRequired}
                    label={label}
                    hasMoreThanThreeValues={hasMoreThanThreeValues}
                    subField={subField}
                    onTextInputChange={this.handleTextInputChange}
                    validator={this.props.validator}
                    lang={this.props.lang}
                    viewProvider={this.props.viewProvider}
                    isInvalid={this.props.showValidationErrors}
                />;
            }
            else {
                viewToDisplay = <CheckboxView
                    key={i}
                    name={item.value}
                    value={includes(this.props.value, item.value)}
                    onChange={this.handleChecked} 
                    isRequired={this.props.isRequired}
                    label={label}
                    hasMoreThanThreeValues={hasMoreThanThreeValues}
                    isInvalid={this.props.showValidationErrors}
                />;
            }
            const wrappedChildren = (children) => <div>{children}</div>;
            return (              
                <ConditionalWrapper
                    key={i}
                    condition={hasMoreThanThreeValues}
                    wrapper={wrappedChildren}
                >
                    {viewToDisplay}
                </ConditionalWrapper>
                
            );
        });

        return (
            <ReactFormGroupWrapper {...this.props}>
                {checkboxes}
            </ReactFormGroupWrapper>
        );
    }
}

ReactFormFieldTags.propTypes = {
    name: PT.string,
    value: PT.any,
    onChange: PT.func,
    validationErrors: PT.array,
    showValidationErrors: PT.bool,
    viewProvider: PT.object,
    possibleValues: PT.array,
    isRequired: PT.bool,
    lang: PT.string,
    onTextInputChange: PT.func,
    subFields: PT.array, // basically, it's an array of ReactFormField
    onSubFieldChange: PT.func,
    onFieldOrSubFieldChange: PT.func,
    validator: PT.func
};

ReactFormFieldTags.defaultProps = {
    value: ""
};
